import React from "react";
import ReactPlayer from "react-player";
import PropTypes from "prop-types";

import { Variables } from "../../styles/Variables";
import IconClose from "../../components/Icons/IconClose";

import { Modal, Content, Close, ContainerVideo } from "./styles";

const ModalVideo = ({ modalOpen, setModalOpen }) => {
  return (
    modalOpen && (
      <Modal>
        <Content>
          <Close onClick={() => setModalOpen(false)}>
            <IconClose color={Variables.colorBlackDark} width={25} height={25} />
          </Close>
          <ContainerVideo>
            <ReactPlayer url="/VideoExplication.mp4" controls width="100%" height="100%" />
          </ContainerVideo>
        </Content>
      </Modal>
    )
  );
};

ModalVideo.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
};

export default ModalVideo;
